module.exports = __webpack_public_path__ + "static/media/montblanc-what-moves-you-makes-you.d24319aa.jpg";